import { TwitchConfigContext } from "@/context/twitchConfigContext";
import { useTwitchConfigState } from "@/hooks/useTwitchConfig";

export function TwitchConfigProvider({ children }: { children: React.ReactNode }) {
  const value = useTwitchConfigState();
  return <TwitchConfigContext.Provider value={value}>{children}</TwitchConfigContext.Provider>;
}
